import { newsDetail } from '@router'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import Cover from '@component/cover'
import classNames from 'classnames'
import { getTime } from '@utils'

export default function NewsNormal ({
  data
}) {

  const cover = data.coverImg
  return (
    <DisablePrefetchLink className='block group' href={newsDetail(data)} aria-label='go to article'>
      <div className='relative rounded-sm overflow-hidden'>
        <Cover src={cover} hoverScale className={classNames('aspect-[358/200]', {'shadow-md': cover})} alt={data.subject} width={358} height={200} defaultIcon='icon-news-cover'></Cover>
        <div className='p-16 absolute inset-x-0 inset-y-0 flex flex-col items-start justify-between bg-image-mask-sm'>
          <div className={classNames({'text-sm px-12 rounded-sm bg-secondary-light text-secondary leading-24': data.isSponsor})}>{data.isSponsor && data.sponsorName}</div>
          <div className='text-white flex justify-between w-full'>
            <span className='text-sm'>{data.author}</span>
            <time className='text-xs' dateTime={getTime(data.publishAt, 'YYYY-MM-DD HH:mm')}>{getTime(data.publishAt, 'DD MMM YYYY')}</time>
          </div>
        </div>
      </div>
      <div className='min-h-[76px]'>
        <div className='text-font text-base mt-8 line-clamp-2'>{data.subject}</div>
        <div className='text-neutral-5 text-base mt-4 line-clamp-1'>{data.brief}</div>
      </div>
    </DisablePrefetchLink>
  )
}

export function SkeletonCard () {
  return (
    <div className='skeleton-wrap'>
      <span className='h-200'></span>
      <span className='w-10/12 h-12 mt-8'></span>
      <span className='w-6/12 h-10 mt-4'></span>
    </div>
  )
}